<mat-form-field appearance="outline" class="w-100">
  <mat-select [(ngModel)]="model" multiple [required]="required" [disabled]="disabled"
    (openedChange)="openedChange($event)" #multiple [overlapTrigger]="false">
    <mat-select-trigger *ngIf="model && model[0] === 'All'">
      ALL
    </mat-select-trigger>
    <mat-option class="mat-search">
      <ngx-mat-select-search [formControl]="matSelectSearchCtrl" [placeholderLabel]="'Search'"
        [hideClearSearchButton]="false"></ngx-mat-select-search>
    </mat-option>
      <mat-option value="All" *ngIf="data.length > 0" #allSelected (click)="optionAllChanges()">All</mat-option>
      <mat-option *ngFor="let item of filteredData | async" [value]="item" (click)="optionChanges(option)" #option>
        {{item.name}}
      </mat-option>
    <mat-option *ngIf="data.length === 0">No data</mat-option>
  </mat-select>
</mat-form-field>